/** A browser range around a noneditable inline span often has an empty rect.
 * Measure a collapsed range at the actual displayed text edge instead. This is
 * view geometry only: the editor selection remains outside the reference.
 */
export function inlineEmbedEdgeRect(element: HTMLElement, after: boolean): DOMRect | null {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT)
  const texts: Text[] = []
  let current = walker.nextNode()
  while (current) {
    if (current.textContent?.length) {
      texts.push(current as Text)
    }
    current = walker.nextNode()
  }
  if (after) {
    texts.reverse()
  }
  for (const text of texts) {
    const range = document.createRange()
    range.setStart(text, after ? text.length : 0)
    range.collapse(true)
    const rect = range.getBoundingClientRect()
    if (rect.height > 0) {
      return rect
    }
  }
  return null
}

export function inlineEmbedDOMCaretRect(node: Node, offset: number): DOMRect | null {
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return null
  }
  const before = node.childNodes[offset - 1]
  const after = node.childNodes[offset]
  if (before instanceof HTMLElement && before.matches('[data-inline-source-embed]')) {
    return inlineEmbedEdgeRect(before, true)
  }
  if (after instanceof HTMLElement && after.matches('[data-inline-source-embed]')) {
    return inlineEmbedEdgeRect(after, false)
  }
  return null
}
